import { envHelper, handleError } from '../helper';
import { ApiInterface } from '../types';
import { Base } from './base';

const response = () => handleError(-1, `当前平台：${envHelper.platform}，当前登录渠道：${envHelper.channel}，暂不支持`);

export class NoneApi extends Base implements ApiInterface {
  public needRefresh = false; // 是否需要续期，外部可以根据此属性进行事件监听并在续期后处理逻辑
  public refreshed = false;
  public ifRefreshSuccess = false;

  public async login() {
    return response();
  }

  public async logout() {
    return response();
  }

  public async isLogin() {
    return response();
  }

  public async getLoginInfo() {
    return response();
  }

  public async getUserInfo() {
    return response();
  }
}
